import React, { useMemo } from 'react';
import { Invoice, InvoiceDataHistoryType } from '@chiroup/core';
import InvoiceDataHistory from './InvoiceDataHistory';

interface Props {
  invoice: Invoice | null;
}

const InvoiceDataDetails: React.FC<Props> = ({ invoice }) => {
  const history: InvoiceDataHistoryType[] | null = useMemo(() => {
    if (!invoice) return null;
    return (invoice?.invoiceData?.history ?? []).sort(
      (a: InvoiceDataHistoryType, b: InvoiceDataHistoryType) =>
        a.timestamp > b.timestamp ? -1 : b.timestamp > a.timestamp ? 1 : 0,
    );
  }, [invoice]);

  if (!invoice) return null;

  return (
    <div className="relative">
      {history?.map((h, idx) => <InvoiceDataHistory history={h} key={idx} />)}
    </div>
  );
};

export default InvoiceDataDetails;
